"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieToggle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const commonComponents_1 = require("./commonComponents");
const CookieToggle = ({ checked, onChange, dataTestid }) => ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: 'flex', flexDirection: 'column', gap: '4px', mt: 1, mb: 1 }, children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(commonComponents_1.RadioInput, { "data-testid": `${dataTestid}-on`, checked: checked, onChange: onChange, sx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                } }), label: "On" }), (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(commonComponents_1.RadioInput, { "data-testid": `${dataTestid}-off`, checked: !checked, onChange: onChange, sx: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                } }), label: "Off" })] }));
exports.CookieToggle = CookieToggle;
